import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

export const Container = styled.div`

`

export const Text = styled.p`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin: 0;
`

export const T = styled.span`
    font-size: 1.2rem;
    font-weight: bold;
`

export const IconContainer = styled.span`
`

export const PopButton = styled.button`
    position: relative;
    top: 8px;
    cursor: pointer;
    border: none;
    background: transparent;
    font-size: 3rem;
    margin-left: 1rem;
    color: green;
`

export const InnerButton = styled.a`
    border: none;
    background: transparent;
    cursor: pointer;
    margin-top: .5rem;
    svg {
        color: green;
        font-size: 3rem;
    }
`

export const Id = styled.p`
    margin-top: .5rem;
    font-weight: bold;
`